
import { map, filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CurrentUserStateService } from '../../../Core/Users/services/current-user-state.service';
import { userPermissionsEnum } from '../../../Core/Users/enums/user-permissions.enum';

@Injectable()
export class WireRouteGuard implements CanActivate {


    constructor(
        private router: Router,
        private currentUserStateService: CurrentUserStateService) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.currentUserStateService.getPermissions().pipe(
            // Waits til info is fetched from backend
            filter(x => x !== null),
            map(permissions => {
                // TODO : redirect somewhere other than /
                return !!permissions.find(x => x === userPermissionsEnum.newswireplus);
            })
        );
    }
}
